import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div style="text-align: justify;">
      <p class="mb-3">
        Я проснулся сегодня в каком-то необычном настроении. 
        Всё вокруг казалось каким-то вдруг увеличившимся и немного искривленным. 
        «Значит, пришло время», – подумал я. 
        Есть не хотелось, зато очень хотелось пойти в душ, хотя обычно я моюсь вечером. 
        Но зуд под кожей становился невыносимым, и я поспешил под твёрдые тугие струи. 
        Верхняя кожа удивительно легко снялась с меня и слоями упала под ноги. 
        Я затолкал её в специальный люк для отработанных отходов, открыв его в стенке ванны. 
        Затем я открыл другой люк, гораздо больший по размерам, в торце над сливом. 
        Но до этого я с любопытством оглядел себя: каким я стал сейчас? 
        Долго разглядывать было некогда, т.к. руки уже начали превращаться в ласты, и промедли я ещё пару минут, открыть все люки я бы уже не смог, 
        и без посторонней помощи просто задохнулся бы на воздухе. 
        На этот случай были предусмотрены аварийные клапаны, но ими обычно никто не пользовлся, 
        т.к. процедуры перехода были настолько отработаны в результате постоянных многократных тренировок, что они проходили автоматически; 
        тем более,что средства массового управления постоянно поддерживали уровень массового сознания, 
        достаточный для полностью автоматического выполнения всех требуемых функций. 
        Задержав дыхание, чтобы не отравиться воздухом, я нырнул в большой люк и, увлекаемый потоком воды, поплыл вперёд. 
        Плыл я долго и, по мере продвижения, плыть становилось всё легче. 
        Тело удлинилось и сплющилось с боков, став идеально обтекаемым, похожим на нож; голова, ставшая треугольной и заострённой спереди, 
        легко рассекала воду. 
        Руки-ноги превратились в мягкие плавники-ласты, так легко и плавно поворачивающие меня в разные стороны. 
        Я больше не чувствовал своего веса, я был свободен в своей среде и мог двигаться не только вперёд-назад или в стороны, но и вверх-вниз! 
        Невероятное чувство свободы охватило меня. 
        Вот для чего я создан! 
        Не вечно прикованным к земле существом двумерного мира, придавленным к земле притяжением, я должен быть; 
        нет, я наконец обрёл свою истинную форму и полную власть над своим телом! 
        Я свободен! 
        Туннель кончился, и я выплыл в большой бассейн, где было много таких, как я. 
        Они плавали, ныряли, выпрыгивали из воды, сверкая оливковым телом в лучах солнца. 
        Они просто радовались жизни, и я тоже радовался, так полно, так сильно, как никогда до этого на сухой и плоской земле. 
        Я сливался со своей средой: вода была и сверху, и снизу, и вокруг меня; я дышал ею, она держала меня, давала мне силы жить. 
        Никогда воздух и земля не давали мне такого ощущения своего могущества, силы и полноты жизни. 
        Вот оно, моё настоящее Я, вот для чего я рождён! 
        Над нами всегда светило Солнце; в воде время от врмени появлялись растворимые питательные вещества; 
        наши выделения уносились слабым течением, так что вода всегда оставалась чистой. 
        Первое время я только наслаждался этой свободой и чувством слиянности со всем миром, со всем, что меня окружает на планете и вне её. 
        Потом захотелось чего-то ещё, какой-то цели, результата, приложения этой огромной силы, которую я чувствовал в себе. 
        Я знал, что придёт время применить её; и однажды я увидел в стене нашего бассейна проход, которого раньше не замечал. 
        Я поплыл в него,и через узкий канал попал в другой бассейн. 
        Его стенки были намного выше, чем у предыдущего; так высоки, что «небо там казалось с овчинку», ограниченное этими стенками. 
        И странно, именно потому, что его было так мало, оно властно привлекало, манило к себе. 
        Хотелось выпрыгнуть выше этих стенок, вонзиться в небо, слиться с ним… 
        И я, и другие прыгали всё выше и выше, стремясь в это небо. 
        И вот некоторые оставляли в воде свою прекрасную шкурку, выкарабкивались из неё и вылетали наверх в виде каких-то чудовищ: 
        палочкообразное тело, и вместо множества прекрасных плавников – каких-то два огромных, длинных, нелепых выроста… 
        И этими выростами они хлопали в воздухе! 
        И воздух держал их! 
        И они не умирали, не задыхались, а поднимались наверх и скрывались из наших глаз, растворяясь в этом высоком бездонном небе! 
        Как хотелось последовать за ними, как манило это небо! 
        И вот однажды и я, сбросив свою шкурку как футляр, поднялся на воздух … и воздух не обжёг меня! 
        Он влился в меня благоуханной струёй, и я почувствовал удивительную свободу и лёгкость. 
        Разве жизнь в тяжёлой воде могла дать такую свободу?!? 
        Разве эта тяжесть не преследовала меня всюду, хотя я тогда этого не замечал? 
        Вот она, свобода и абсолютная сила: в свободном полёте, в невесомой среде, когда и твоё тело невесомо. 
        Вот где полное слияние со всеми силами Земли! 
        Вот апогей жизни! 
        Солнце даёт нам силу; и всю мудрость и силу древнего Космоса впитывало моё невесомое тело. 
        Долго кружил я в бездонном небе; но вот моё тело стало тяжелеть. 
        Мне захотелось вниз, прикоснуться к земле, слиться с ней, почувствовать её тяжесть. 
        Слишком много силы и знаний во мне накопилось: они требовали глубины, погружения во что-то тяжёлое, мощное, сильное, 
        чтобы моя среда была такой же тяжёлой, обогащённой всем, что я получил за всё время всей своей жизни… 
        Тяжёлым и твёрдым лежало во мне это знание; и в тяжёлом и твёрдом субстрате должно было оно проявиться и, наконец созрев, освободиться, 
        выйти из меня. 
        Я стал как снаряд: округлый, литой, потеряв все отростки и крылья, я врезался, вонзался в землю, сверля её заострённой головой. 
        Какое наслаждение быть сильным в силе, твёрдым в тверди! 
        Но вот все мои желания угасли; я достиг конца своих странствий. 
        Моя шкурка разорвалась, и кучка мягких яиц, покрытых полупрозрачной оболочкой, осталась лежать в земле. 
        Как свиньи вынюхивают трюфели, так специально обученные животные вынюхивают свежие кладки снесённых яиц, 
        и скоро эти яйца были найдены и отправлены в инкубатор. 
        Там, под присмотром Людей, которые и построили эти инкубаторы и вообще всё, что было к тому времени построено на Земле и в Космосе, 
        из этих яиц вывелись новые Люди, обогащённые силами всех четырёх стихий и знанием всех законов жизни на Земле и пониманием сил, 
        действующих в мире. 
        Люди жили, работали, действовали… 
        А потом приходил момент, когда у них начинало чесаться тело и очень хотелось пойти под душ…
      </p>
      
      <p class="text-center bold mb-3">* * *</p>

      <p class="mb-3">
        А вы говорите, отказ от пола! 
        Да, но для чего? 
        Не множественность полов у людей, – а множественность возрастных стадий, по образцу низших беспозвоночных. 
        На новом уровне возврат к истокам. 
        Вот, люди отказались от полового размножения; но не для деградации, а для последующего развития. 
        Ведь только теперь началась моя настоящая жизнь. 
        Закалённый, получивший силу всех четырёх стихий, 
        слившийся со всеми силами природы и сохранивший их в себе – теперь я мог быть по-настоящему Человеком, венцом природы, 
        и жить и творить на Земле в согласии с Природой и разделяя её силу как свою. 
        Таков настоящий путь Человека. 
        Так жизнь на Земле должна была развиваться по естественному плану. 
        Мы сделали огромную петлю, выделив позвоночных; но всё же мы вернулись в Великому Началу, вернулись на новой ступени. 
        И мир принял нас. 
        Мы нашли свой путь, вернувшись в Природу, и вместе с Природой мы стали вечны и непобедимы. 
        Мы нашли источник Жизни и слились с ним.
      </p>
      
      <p class="mb-3">
        Сим победиши!
      </p>
    

    </div>
    `
  )
}

const itemName = {
  rus: `Зачем нам множественность полов`
}

const itemDate = {
  rus: `18 сент.-3-8`
}

const item = {
  itemlink: getLink(itemName.rus),
  rus: {
    itemName: itemName.rus + '?',
    itemDate: itemDate.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}

export default item;